// Environment konfigürasyon dosyası
// Bu dosya local ve production ortamları için farklı URL'ler sağlar

// React environment değişkenlerini kontrol et
const getEnvironmentConfig = () => {
  // REACT_APP_API_BASE_URL environment değişkeni varsa onu kullan
  if (process.env.REACT_APP_API_BASE_URL) {
    return {
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
      BASE_URL: process.env.REACT_APP_API_BASE_URL.replace('/api', ''),
      PORT: 5000
    };
  }
  
  // Environment değişkeni yoksa NODE_ENV'e göre belirle
  const isProduction = process.env.NODE_ENV === 'production';
  
  if (isProduction) {
    return {
      API_BASE_URL: 'https://support.apro.com.tr/api',
      BASE_URL: 'https://support.apro.com.tr',
      PORT: 5000
    };
  }
  
  // Local geliştirme ortamı için localhost kullan
  return {
    API_BASE_URL: 'http://localhost:5000/api',
    BASE_URL: 'http://localhost:5000',
    PORT: 5000
  };
};

// Konfigürasyonu export et
export const config = getEnvironmentConfig();

// Kolay kullanım için ayrı ayrı export et
export const API_BASE_URL = config.API_BASE_URL;
export const BASE_URL = config.BASE_URL;
export const PORT = config.PORT;
